import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../redux-store';

// Basic selectors
export const selectActiveClient = (state: RootState) => state.activeClient.activeClient;
export const selectActiveClientLoading = (state: RootState) => state.activeClient.isLoading;
export const selectActiveClientError = (state: RootState) => state.activeClient.error;

// Computed selectors
export const selectActiveClientId = createSelector(
  [selectActiveClient],
  (activeClient) => activeClient?.ext_client_id || null
);

export const selectActiveClientTitle = createSelector(
  [selectActiveClient],
  (activeClient) => activeClient?.title || 'No Client Selected'
);

export const selectActiveClientViews = createSelector(
  [selectActiveClient],
  (activeClient) => activeClient?.views || []
);

export const selectActiveClientBrand = createSelector(
  [selectActiveClient],
  (activeClient) => activeClient?.brand || null
);

export const selectActiveClientCompany = createSelector(
  [selectActiveClient],
  (activeClient) => activeClient?.companies || null
);

// Check if client is active
export const selectIsClientActive = createSelector(
  [selectActiveClient],
  (activeClient) => activeClient !== null
);
